import { render, staticRenderFns } from "./createApp.vue?vue&type=template&id=2d30de48&scoped=true"
import script from "./createApp.vue?vue&type=script&lang=js"
export * from "./createApp.vue?vue&type=script&lang=js"
import style0 from "./createApp.vue?vue&type=style&index=0&id=2d30de48&prod&lang=less&scoped=true"
import style1 from "./createApp.vue?vue&type=style&index=1&id=2d30de48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d30de48",
  null
  
)

export default component.exports